import React, { useState, memo } from 'react';
import { HandshakeIcon } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { AlliesShowcase } from '../components/AlliesShowcase';
const inputClass = 'w-full h-12 px-4 text-[15px] border-[1.5px] border-[#e0e0e0] rounded-lg outline-none focus:border-primary transition-colors';
const labelClass = 'block text-sm font-semibold text-[#333] mb-1.5';
const allianceTypes = [{
  icon: '🏢',
  title: 'Empresa',
  subtitle: 'Responsabilidad social corporativa',
  value: 'empresa'
}, {
  icon: '💚',
  title: 'Fundación',
  subtitle: 'Colaboración filantrópica',
  value: 'fundacion'
}, {
  icon: '🩺',
  title: 'Profesional de salud',
  subtitle: 'Red de especialistas',
  value: 'profesional_salud'
}, {
  icon: '🏛️',
  title: 'Entidad gubernamental',
  subtitle: 'Programas de impacto social',
  value: 'entidad_gubernamental'
}, {
  icon: '🎓',
  title: 'Institución educativa',
  subtitle: 'Investigación y formación',
  value: 'institucion_educativa'
}, {
  icon: '🌟',
  title: 'Marca comprometida',
  subtitle: 'Alianzas estratégicas',
  value: 'marca_comprometida'
}];
const aporteOptions = ['Financiamiento o donaciones', 'Servicios profesionales', 'Recursos educativos', 'Voluntariado', 'Difusión y comunicación', 'Infraestructura o espacio físico', 'Otro'];
export function QuieroSerAliado() {
  const [tipoAlianza, setTipoAlianza] = useState('');
  useDocumentMeta({
    title: 'Ser Aliado | Pancita Feliz Foundation',
    description: 'Únete como aliado de Pancita Feliz Foundation y ayuda a transformar vidas de familias venezolanas.',
    path: '/quiero-ser-aliado'
  });
  return <main className="w-full" data-id="element-466" data-mp="290im9j4or2ua">
      {/* Hero */}
      <section className="text-center" style={{
      background: 'linear-gradient(135deg, #f0f7e6 0%, #e8f5d0 100%)',
      padding: '60px 20px 40px'
    }} data-id="element-467" data-mp="2myqhnmm2pw3c">
        <HandshakeIcon style={{
        width: '64px',
        height: '64px',
        color: '#7DC920',
        background: 'white',
        borderRadius: '50%',
        padding: '16px',
        boxShadow: '0 4px 16px rgba(125,201,32,0.2)',
        display: 'block',
        margin: '0 auto 24px auto'
      }} data-id="element-468" data-mp="2q1mtoxlj3jwb" />
        <h1 className="font-bold text-[#1a1a1a] mb-4" style={{
        fontSize: '42px'
      }} data-id="element-469" data-mp="38rmgtext6ox3">
          Quiero ser Aliado
        </h1>
        <p className="mx-auto" style={{
        fontSize: '18px',
        color: '#555',
        maxWidth: '600px'
      }} data-id="element-470" data-mp="3dourkugmnqob">
          Únete a nuestra red de aliados y juntos transformemos el futuro del
          neurodesarrollo familiar
        </p>
      </section>

      {/* Form */}
      <section className="px-4 py-12 bg-white" data-id="element-471" data-mp="1takmg91tden9">
        <div className="mx-auto bg-white" style={{
        maxWidth: '680px',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        padding: '48px',
        marginBottom: '60px'
      }} data-id="element-472" data-mp="1tbdwbiw2kk9m">
          <form action="https://formspree.io/f/mpqgrdzr" method="POST" data-id="element-473" data-mp="1mmityx3pj8j">
            <input type="hidden" name="_replyto" value="info@pancitafelizfoundation.org" data-id="element-474" data-mp="3stz34mta6cso" />
            <input type="hidden" name="_subject" value="🤝 Nueva Solicitud de Alianza - Pancita Feliz Foundation" data-id="element-475" data-mp="tdaif6j4mgk3" />

            <h2 className="text-[22px] font-bold text-[#1a1a1a] mb-8" data-id="element-476" data-mp="kd4by4luiguf">
              Información del Aliado
            </h2>

            {/* Personal / Organizational */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4" data-id="element-477" data-mp="3544u6gc318dp">
              Información Personal / Organizacional
            </p>

            <div className="mb-5" data-id="element-478" data-mp="303gsn0q89958">
              <label className={labelClass} data-id="element-479" data-mp="rwdc1zbqzn0h">
                Nombre completo / Razón social
              </label>
              <input type="text" name="nombre_organizacion" required placeholder="Tu nombre o nombre de tu organización" className={inputClass} data-id="element-480" data-mp="wmtr1nv7vgoy" />
            </div>

            <div className="mb-5" data-id="element-481" data-mp="nv03hhh9t5pv">
              <label className={labelClass} data-id="element-482" data-mp="1bkm3g75gvoyx">Correo electrónico</label>
              <input type="email" name="email" required placeholder="correo@empresa.com" className={inputClass} data-id="element-483" data-mp="1bi8960im2gsf" />
            </div>

            <div className="mb-5" data-id="element-484" data-mp="16kzpfvhte4p2">
              <label className={labelClass} data-id="element-485" data-mp="16k6t7oghexl6">Teléfono / WhatsApp</label>
              <input type="tel" name="telefono" required placeholder="+1 (000) 000-0000" className={inputClass} data-id="element-486" data-mp="3mcnnju8ke39g" />
            </div>

            <div className="mb-5" data-id="element-487" data-mp="3jqwp1wxmytv1">
              <label className={labelClass} data-id="element-488" data-mp="3ju2cz8uj3pp6">Sitio web (opcional)</label>
              <input type="url" name="sitio_web" placeholder="https://www.tusitio.com" className={inputClass} data-id="element-489" data-mp="3es38fvn1ymqn" />
            </div>

            <div className="mb-5" data-id="element-490" data-mp="3nu2oolq8tmsj">
              <label className={labelClass} data-id="element-491" data-mp="303ynel0j1z4p">País</label>
              <select name="pais" required className={inputClass} defaultValue="" data-id="element-492" data-mp="304rujn3eeqnd">
                <option value="" disabled data-id="element-493" data-mp="39ubhb3u8f4ni">
                  Selecciona tu país
                </option>
                <option data-id="element-494" data-mp="352jriviwh2yf">Venezuela</option>
                <option data-id="element-495" data-mp="351qp26qz4zm3">Colombia</option>
                <option data-id="element-496" data-mp="2hd7j3xvecyx6">México</option>
                <option data-id="element-497" data-mp="2hc645ib9fsa6">Estados Unidos</option>
                <option data-id="element-498" data-mp="2cee39ysn0vtu">España</option>
                <option data-id="element-499" data-mp="2cdcrfs3ss5b2">Otro</option>
              </select>
            </div>

            {/* Alliance type */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4 mt-8" data-id="element-500" data-mp="gagfmc4738fx">
              Tipo de Alianza
            </p>

            <div className="mb-6" data-id="element-501" data-mp="l7zsb7l8vd5r">
              <label className={labelClass} data-id="element-502" data-mp="q0sxfwkmknid">¿Cómo deseas ser aliado?</label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2" data-id="element-503" data-mp="uzw2vi4iovqv">
                {allianceTypes.map(type => {
                const selected = tipoAlianza === type.value;
                return <label key={type.value} className="cursor-pointer transition-colors" style={{
                  border: `2px solid ${selected ? '#7DC920' : '#e0e0e0'}`,
                  borderRadius: '12px',
                  padding: '16px',
                  background: selected ? '#f0f7e6' : '#ffffff'
                }} data-id="element-504" data-mp="2aynbmroxd1t">
                      <input type="radio" name="tipo_alianza" value={type.value} checked={selected} onChange={() => setTipoAlianza(type.value)} className="sr-only" required data-id="element-505" data-mp="1mpih9sftbq6z" />
                      <div style={{
                    fontSize: '24px'
                  }} data-id="element-506" data-mp="2tgwjwsknophz">
                        {type.icon}
                      </div>
                      <div className="text-[#1a1a1a] mt-1" style={{
                    fontSize: '14px',
                    fontWeight: 600
                  }} data-id="element-507" data-mp="2ji8dys5y40un">
                        {type.title}
                      </div>
                      <div style={{
                    fontSize: '12px',
                    color: '#666'
                  }} data-id="element-508" data-mp="doqrw3upuosu">
                        {type.subtitle}
                      </div>
                    </label>;
              })}
              </div>
            </div>

            {/* Details */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4 mt-8" data-id="element-509" data-mp="341paboetdngb">
              Detalles
            </p>

            <div className="mb-6" data-id="element-510" data-mp="2v1iw20bakjg3">
              <label className={labelClass} data-id="element-511" data-mp="2v0hldwy6tyyw">
                ¿Qué puedes aportar como aliado?
              </label>
              <div className="grid sm:grid-cols-2 gap-3 mt-2" data-id="element-512" data-mp="2z4fik23yczpb">
                {aporteOptions.map(option => <label key={option} className="flex items-center gap-3 cursor-pointer text-[15px] text-[#333]" data-id="element-513" data-mp="2l57kxdnftzn8">
                    <input type="checkbox" name="aporte" value={option} className="w-5 h-5 accent-primary" data-id="element-514" data-mp="jd1ec21dbsfw" />
                    {option}
                  </label>)}
              </div>
            </div>

            <div className="mb-8" data-id="element-515" data-mp="23ro7h5gmne7m">
              <label className={labelClass} data-id="element-516" data-mp="2ij6u3m3zs6zy">
                Cuéntanos sobre tu organización y cómo quieres colaborar
              </label>
              <textarea name="mensaje" required rows={5} placeholder="Describe tu organización, tu misión y cómo crees que podemos trabajar juntos..." className="w-full px-4 py-3 text-[15px] border-[1.5px] border-[#e0e0e0] rounded-lg outline-none focus:border-primary transition-colors resize-none" data-id="element-517" data-mp="2dqdqj1k9f4pg" />
            </div>

            <button type="submit" className="w-full text-white font-bold rounded-xl transition-colors hover:bg-[#6ab518]" style={{
            height: '52px',
            fontSize: '16px',
            background: '#7DC920'
          }} data-id="element-518" data-mp="2wj7xb87qbqil">
              Enviar Solicitud de Alianza
            </button>

            <p className="text-center mt-4" style={{
            fontSize: '12px',
            color: '#888'
          }} data-id="element-519" data-mp="1razek46u20xd">
              🔒 Tu información es confidencial y será tratada con total
              privacidad
            </p>
          </form>
        </div>
      </section>

      <AlliesShowcase data-id="element-520" data-mp="2f3fyyle1m4zu" />
    </main>;
}